import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectQuietTimes } from '../../../../redux/slices/quietTimesSlice/quietTimesSlice';

const QuietTimesDropdown = ({
  updateField, createSchedule, quietTimeId, disabled,
}) => {
  const scheduleList = useSelector(selectQuietTimes);

  const getSelectedId = () => (quietTimeId == null ? '-1' : String(quietTimeId));

  const [selectedValue, setSelectedValue] = useState(getSelectedId());

  useEffect(() => {
    setSelectedValue(getSelectedId());
  }, [quietTimeId]);

  const updateSchedule = (e) => {
    const { value } = e.target;

    if (value === '__create__') {
      setSelectedValue(getSelectedId());
      createSchedule();
      return;
    }

    setSelectedValue(value);

    if (value === '-1') {
      updateField('quietTimeId', null);
      return;
    }

    const newId = parseInt(value, 10);
    updateField('quietTimeId', newId);
  };

  return (
    <div style={{ width: '230px' }}>
      <div className="row form-inline">
        <span className="col-12" style={{ fontWeight: 'bold', fontSize: '15px' }}>
          Quiet Time
        </span>
      </div>
      <div className="row form-inline-block">
        <div className="col-12">
          <select
            className="form-control"
            onChange={updateSchedule}
            value={selectedValue}
            aria-label="quiet-time"
            disabled={disabled}
          >
            <option value="-1">- None -</option>
            {scheduleList.map((schedule) => (
              <option key={schedule.id} value={String(schedule.id)}>
                {schedule.name}
              </option>
            ))}
            <option key="0" value="__create__">- Create new schedule -</option>
          </select>
        </div>
      </div>
    </div>
  );
};

QuietTimesDropdown.defaultProps = { quietTimeId: null };

QuietTimesDropdown.propTypes = {
  updateField: PropTypes.func.isRequired,
  createSchedule: PropTypes.func.isRequired,
  quietTimeId: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
};

export { QuietTimesDropdown };
export default QuietTimesDropdown;
